import React from 'react';
import { Carousel } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faPhone, faEnvelope, faClock, faBaby, faUser } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css';

function Home() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  React.useEffect(() => {
    // Add Google Fonts
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@300;400;500&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleWhatsAppClick = () => {
    const phoneNumber = '491737236489';  
    const message = 'Hallo! Ich interessiere mich für eine Behandlung bei KosmetikerinGreta.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavClick = (sectionId) => {
    scrollToSection(sectionId);
    setIsMenuOpen(false);
  };

  return (
    <div className="home">
      <nav className="navigation">
        <div className="nav-content">
          <div className="desktop-nav">
            <button onClick={() => scrollToSection('about')}>Über Mich</button>
            <button onClick={() => scrollToSection('hydrafacial')}>HydraFacial</button>
            <button onClick={() => scrollToSection('services')}>Leistungen</button>
            <button onClick={() => scrollToSection('contact')}>Kontakt</button>
          </div>
          <button className="mobile-menu-toggle" onClick={toggleMenu}>
            <div className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>
        </div>
        <div className={`mobile-nav ${isMenuOpen ? 'active' : ''}`}>
          <button onClick={() => handleNavClick('about')}>Über Mich</button>
          <button onClick={() => handleNavClick('hydrafacial')}>HydraFacial</button>
          <button onClick={() => handleNavClick('services')}>Leistungen</button>
          <button onClick={() => handleNavClick('contact')}>Kontakt</button>
        </div>
      </nav>

      <div className="site-title">
        <h1>KosmetikerinGreta</h1>
        <div className="subtitle">make your skin glow</div>
      </div>

      <section className="hero-section">
        <div className="hero-content">
          <div className="hero-text">
            <h2>Neuer Glanz für Ihre Haut</h2>
            <p>
              Entfallen Sie den natürlichen Glanz Ihrer
              Haut mit unseren luxuriösen Gesichtsbehandlungen!
              Unsere Produkte wurden entwickelt, um Ihre Haut zu verjüngen und zu
              erfrischen, und hinterlassen einen glatten, strahlenden Teint.
              Gönnen Sie sich das ultimative Hautpflegeerlebnis und strahlen Sie wie nie zuvor!
            </p>
            <button onClick={handleWhatsAppClick} className="cta-button">
              <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
              Termin buchen
            </button>
          </div>

          <div className="carousel-section">
            <Carousel
              fade
              interval={5000}
              indicators={true}
              pause="hover"
              touch={true}
            >
              <Carousel.Item>
                <img
                  className="d-block"
                  src="/img/WhatsApp Image 2024-11-25 at 11.25.23 PM.jpeg"
                  alt="First slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block"
                  src="/img/WhatsApp Image 2024-11-25 at 11.25.23 PM (1).jpeg"
                  alt="Second slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block"
                  src="/img/WhatsApp Image 2024-11-25 at 11.25.23 PM (2).jpeg"
                  alt="Third slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block"
                  src="/img/WhatsApp Image 2024-11-25 at 11.25.25 PM.jpeg"
                  alt="Fourth slide"
                />
              </Carousel.Item>
              <Carousel.Item>
                <img
                  className="d-block"
                  src="/img/WhatsApp Image 2024-11-25 at 11.25.25 PM (2).jpeg"
                  alt="Fifth slide"
                />
              </Carousel.Item>
            </Carousel>
          </div>
        </div>
      </section>

      <section id="about" className="about-section">
        <div className="about-content">
          <div className="about-image">
            <img
              src="/img/pricelist.jpeg"
              alt="Preisliste"
            />
          </div>
          <div className="about-text">
            <h2>Über Mich</h2>
            <p>
              Ich bin Greta, ausgebildete Fachkosmetikerin. Ich bringe Erfahrung in der Hautpflege mit.
            </p>
            <p>
              Mein Ziel ist es, individuelle Behandlungen anzubieten, die auf die Bedürfnisse meiner Kunden abgestimmt sind.
              Ich liebe es, Menschen zum Strahlen zu bringen und halte mich stets über die neuesten Trends in der Branche informiert.
            </p>
            <p>
              Ich freue mich auf dich!
            </p>
            <p className="signature">
              Greta
            </p>
          </div>
        </div>
      </section>

      <section id="hydrafacial" className="hydrafacial-section">
        <div className="hydrafacial-content">
          <div className="hydrafacial-text">
            <div className="hydrafacial-logo">
              <img
                src="/img/hydrafacial.png"
                alt="HydraFacial"
              />
            </div>
            <p>
              Hydrafacial ist eine innovative Gesichtsbehandlung,
              die mehrere Schritte kombiniert, um die Haut zu reinigen, zu peelen,
              zu extrahieren und mit Feuchtigkeit zu versorgen.
            </p>
            <p>
              Die Hydrafacial-Behandlung ist für alle Hauttypen geeignet und kann helfen,
              das Hautbild zu verbessern, die Poren zu verfeinern und einen strahlenden Teint zu fördern.
              Viele Menschen schätzen die sofort sichtbaren Ergebnisse und das entspannende Gefüh.
            </p>
            <p>
              Vorteile auf einen Blick
            </p>
            <ul className="treatment-benefits">
              <li>Strahlende, glatte und schöne Haut</li>
              <li>Für alle Hauttypen geeignet</li>
              <li>Verbesserung der Hautstruktur und -farbe</li>
              <li>Porenverfeinerung</li>
              <li>Wissenschaftlich nachgewiesene Wirksamkeit</li>
            </ul>
          </div>
        </div>
      </section>

      <section id="services" className="services-section">
        <div className="services-content">
          <h2>Unsere Behandlungen</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Basic Behandlung</h3>
              <p className="service-description">
                Abreinigen, Peeling(Enzyme oder Säure), Ausreinigen, Massage, Maske, AbschlussPflege.
              </p>
              <div className="service-details">
                <span className="duration">90 Min</span>
                <span className="price">87€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Oxygen Behandlung</h3>
              <p className="service-description">
                Abreinigen, Cocoa Enzym-Peeling, Oxygen, Maske, AbschlussPflege.
              </p>
              <div className="service-details">
                <span className="duration">110 Min</span>
                <span className="price">167€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Needling</h3>
              <p className="service-description">
                Abreinigen, Needling + Serum, Maske, AbschlussPflege.
              </p>
              <div className="service-details">
                <span className="duration">90 Min</span>
                <span className="price">107€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Stem Cell Booster</h3>
              <p className="service-description">
                Abreinigung, Herbs2peel, Tonisieren, Massage mit Elixier und Maske, Bio Cellulose Stem Cell Maske, AbschlussPflege mit Stem Cell cream.
              </p>
              <div className="service-details">
                <span className="duration">90 Min</span>
                <span className="price">127€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Skin Smoothie Behandlung</h3>
              <p className="service-description">
                Abreinigung, Herbs2peel, Tonisieren, SkinsuperFood Ampulle, Bio Cellulose Stem Cell Maske, AbschlussPflege.
              </p>
              <div className="service-details">
                <span className="duration">90 Min</span>
                <span className="price">117€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Clarity Behandlung</h3>
              <p className="service-description">
                Abreinigung, Herbs2peel, Deepgel, Detoxmaske, Abschluss.
              </p>
              <div className="service-details">
                <span className="duration">90 Min</span>
                <span className="price">97€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Hydrafacial Signature</h3>
              <p className="service-description">
                Manuelle Abreinigung, Reinigung und Glysal Säurepeeling Tiefenausreinigung, manuelle Ausreinigung und Versorgung mit Antiox+
              <br/>
              Bitte 1 Woche vor der Behandlung auf Retinol, Peeling und andere aktive Wirkstoffe in der Heimpflege verzichten!</p>
              <div className="service-details">
                <span className="duration">70 Min</span>
                <span className="price">167€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Hydrafacial Deluxe</h3>
              <p className="service-description">
                Manuelle Abreinigung, Reinigung und Glysal Säurepeeling, Tiefenausreinigung, manuelle Ausreinigung, hautspezifischer Hydrafacial Booster, LED Lichttherapie und Versorgung mit Antiox+
                <br/>
                Bitte 1 Woche veo der Behandlung auf Retinol,Peeling und andere aktive Wirkstoffe in der Heimpflege verzichten!</p>
              <div className="service-details">
                <span className="duration">90 Min</span>
                <span className="price">187€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Hydrafacial JLO Glow</h3>
              <p className="service-description">
                <b>Für den perfekten Glow</b><br/>
                Lymphdrainage, Abreinigung, Abtragung mit Activ4, Glysal Säurepeeling, Tiefausreinigung, manuelle Ausreinigung, JLo Beauty Booster (sorgt für Straffung, Aufhellung, Feuchtigkeitsversorgung und zaubert den typischen Jennifer Lopez Glow)
                Lichttherapie rot oder blau, Versorgung mit Antiox+ und Abschlusspflege
                <br/>
                Bitte voher Zuhause auf Retinol und Peelings verzichten</p>
              <div className="service-details">
                <span className="duration">90 Min</span>
                <span className="price">247€</span>
              </div>
            </div>

            <div className="service-card">
              <h3>Augenbrauenlifting</h3>
              <p className="service-description">
                Augenbrauenlifting ist ein Verfahren, das dazu dient, 
                die Augenbrauen anzuheben und dem Gesicht ein frischeres, wacheres Aussehen zu verleihen.
                <br/>
                Bitte voher Zuhause auf Retinol und Peelings verzichten</p>
              <div className="service-details">
                <span className="price">Ohne färben 40€</span>
                <span className="price">Mit färben 45€</span>
              </div>
            </div>

          </div>
        </div>
      </section>

      <footer id="contact" className="footer-section">
        <div className="footer-content">
          <div className="footer-info">
            <div className="footer-column">
              <h4>Kontakt</h4>
              <p>
                <FontAwesomeIcon icon={faUser} className="footer-icon" />
                <a href="#">Greta Doganay</a><br/>
              </p>
              <p>
                <FontAwesomeIcon icon={faPhone} className="footer-icon" />
                <a href="tel:+49 173 7236489">+49 173 7236489</a>
              </p>
              <p>
                <FontAwesomeIcon icon={faWhatsapp} className="footer-icon whatsapp-icon" />
                <a href="#" onClick={handleWhatsAppClick}>WhatsApp</a>
              </p>
              <p>
                <FontAwesomeIcon icon={faInstagram} className="footer-icon" />
                <a href="https://instagram.com/kosmetikeringreta" target="_blank" rel="noopener noreferrer">
                  @kosmetikeringreta
                </a>
              </p>
              <p>
                <FontAwesomeIcon icon={faClock} className="footer-icon" style={{ opacity: 0 }} />
                Steuer nr: 44/031/72905
              </p>
            </div>

            <div className="footer-column">
              <h4>Adresse</h4>
              <p>
                <FontAwesomeIcon icon={faMapMarkerAlt} className="footer-icon" />
                Bozener str. 64
              </p>
              <p>
                <FontAwesomeIcon icon={faMapMarkerAlt} className="footer-icon" style={{ opacity: 0 }} />
                67067 Ludwigshafen am Rhein
              </p>
            </div>

            <div className="footer-column">
              <h4>Öffnungszeiten</h4>
              <p>
                <FontAwesomeIcon icon={faClock} className="footer-icon" />
                Mo - Fr: 9:00 - 17:00
              </p>
              <p>
                <FontAwesomeIcon icon={faClock} className="footer-icon" style={{ opacity: 0 }} />
                Sa: 10:00 - 14:00
              </p>
            </div>
          </div>

          <div className="footer-bottom">
            <p>&copy; 2024 KosmetikerinGreta. Alle Rechte vorbehalten.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;
